import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/common.css'
import { scrollPageToTop } from './utils/pageNavigation'
import { setUnauthorizedHandler } from './api/http'
import { clearAuth } from './utils/auth'

Vue.config.productionTip = false

function scheduleScrollToTop() {
  Vue.nextTick(() => {
    requestAnimationFrame(() => {
      scrollPageToTop()
    })
  })
}

router.afterEach((to, from) => {
  if (!from || to.fullPath !== from.fullPath) {
    scheduleScrollToTop()
  }
})

window.addEventListener('hashchange', scheduleScrollToTop)

setUnauthorizedHandler(() => {
  clearAuth()
  store.commit('CLEAR_AUTH')
  store.commit('SHOW_LOGIN', router.currentRoute.fullPath)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

scheduleScrollToTop()
